import { isNumber } from 'lodash';

import { makeMonetaryAmount, MonetaryAmountStrict, SupportedCurrencyCode } from './currency';

export type MonetaryAmountTuple = [MonetaryAmountStrict | '', MonetaryAmountStrict | ''];

export const serializeValue = (value: [number | '', number | ''], currencyCode: SupportedCurrencyCode) => [
  isNumber(value[0]) ? makeMonetaryAmount(value[0], currencyCode) : value[0],
  isNumber(value[1]) ? makeMonetaryAmount(value[1], currencyCode) : value[1],
];

export const deserializeValue = (
  value: MonetaryAmountTuple | undefined | null,
  currencyCb?: (value: number, currencyCode: SupportedCurrencyCode) => number,
): [number | '', number | ''] => {
  if (!value || !Array.isArray(value)) return ['', ''];

  const [left, right] = value;

  return [
    left === '' ? '' : (currencyCb?.(left.amount, left.currency as SupportedCurrencyCode) ?? left.amount),
    right === '' ? '' : (currencyCb?.(right.amount, right.currency as SupportedCurrencyCode) ?? right.amount),
  ];
};
